/**
 * Process the response from the LLM to improve formatting
 * - Standardizes links to markdown format
 * - Transforms raw URLs into "Clique aqui!"
 * - Removes excessive newlines
 */
export function processResponse(text: string): string {
    if (!text) return '';

    // Fix broken links (e.g. <https://...>)
    let processed = text.replace(/<(https?:\/\/[^>]+)>/g, '$1');

    // Transform raw URLs into [Clique aqui!](url)
    // Regex matches URLs that are NOT already inside markdown links like [text](url) or (url)
    // Negative lookbehind is not fully supported in all JS environments, so we use a safer approach:
    // We match URLs and then check if they are part of a markdown link construction.
    // However, for simplicity and the specific format coming from Gemini:

    // Pattern: Find http/https links that are surrounded by whitespace or start of line, 
    // and are NOT immediately preceded by `](` or `(` (part of markdown link)
    // This is complex to do perfectly with one regex.

    // Alternative from backend:
    // const urlRegex = /(https?:\/\/[^\s<]+[^<.,:;"')\]\s])|(<(https?:\/\/[^>]+)>)/g;

    // Let's use a simple replacement for now, assuming Gemini output behavior.
    // Gemini often outputs: "Assista aula tal: https://..."

    // We want to turn `https://...` into `[Clique aqui!](https://...)`
    // BUT IGNORE if it's already `[...](https://...)`

    // Strategy: Split by Markdown links, process text parts, rejoin.
    // Or simpler: Use the backend logic which seemed to work.

    // Backend regex was:
    // text.replace(/(?<!\]\()https?:\/\/[^\s)]+/g, (url) => `[Clique aqui!](${url})`);
    // But lookbehind `(?<!...)` support in older browsers/safari might be an issue? 
    // Vite handles targets, but let's be safe.
    // Actually, widespread support for lookbehind exists in modern browsers.

    try {
        processed = processed.replace(/(?<!\]\(|\[)https?:\/\/[^\s)<]+(?![^\[]*\])/g, (url) => {
            // Clean trailing punctuation
            const cleanUrl = url.replace(/[.,:;]+$/, '');
            return `[Clique aqui!](${cleanUrl})`;
        });
    } catch (e) {
        // Fallback for browsers without lookbehind support (rare nowadays for modern web apps)
        // Just leave URLs as is or use simpler regex
        // processed = processed; 
        console.warn('Regex lookbehind not supported', e);
    }

    // Remove excessive newlines (more than 2)
    processed = processed.replace(/\n{3,}/g, '\n\n');

    return processed;
}
